/** Map requested facet values to the stored strings that trim-equal them. */
export function expandFacetMatches(
  stored: Array<string | null | undefined>,
  requested: string[]
): string[] {
  const wanted = new Set(requested.map((value) => value.trim()).filter(Boolean));
  if (!wanted.size) return [];

  const matches = new Set<string>();
  for (const value of stored) {
    if (value && wanted.has(value.trim())) {
      matches.add(value);
    }
  }
  return [...matches];
}

export function trimFacetValue(value: string | null | undefined): string | undefined {
  const trimmed = value?.trim();
  return trimmed || undefined;
}
